let isEU = false

document.addEventListener('DOMContentLoaded', () => {
	let country = 'GB'

	if(localStorage.getItem('countryCode')) {
		country = localStorage.getItem('countryCode')
	}
	let urlCountry = (new URL(document.location)).searchParams.get('country')
	if(urlCountry) {
		country = urlCountry
	}

	fetch('https://ipinfo.io/json')
		.then(response => response.json())
		.then(data => {
			if(data.country) {
				country = data.country
				localStorage.setItem('countryCode', country)
			}
		})
		.catch(error => {
			console.error(error)
		})

	const euCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK']
	if(euCountries.includes(country)) {
		isEU = true
	}

	updateShippingText(country)
})

function updateShippingText(country) {
	// Check if shipping block exists on product page
	let shippingSection = null
	const productBlocks = document.querySelectorAll('.product-info__block-item[data-block-type="text"]')
	for(const block of productBlocks) {
		if(block.innerHTML.toLowerCase().includes('<h2 class="h6">shipping</h2>')) {
			shippingSection = block
			break
		}
	}

	if(!shippingSection) {
		return
	}

	const productShippingText = shippingSection.querySelector('.prose')
	if(!productShippingText) {
		return
	}

	// Find shipping text for country or suitable fallback
	let foundText = document.querySelector(`.country-shipping-text[country-code="${country}"]`)
	if(!foundText && isEU) {
		foundText = document.querySelector(`.country-shipping-text[country-code="EU"]`)
	}
	if(!foundText) {
		foundText = document.querySelector(`.country-shipping-text[country-code="GB"]`)
	}

	if(foundText) {
		productShippingText.innerHTML = foundText.innerHTML
	}
}
